import React from "react";
import "../../styles/glass.css"
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css"
import "../styles/LeftSidebar.css"
import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import { useCurrentLang } from "../../hooks/useCurrentLang";
export const NotFoundPage = () => {
    return(
        <div className='revimo-layout'>
            <HeaderPlatform/>
            <main className="revimo-main">
            <LeftSidebar/>
            <div className="revimo-page-content">
                <GlassCard>
                    <h1 style={{color: "var(--text-main)"}}>
                        Session not found...
                    </h1>
                </GlassCard>

            </div>
            </main>
            <footer className="revimo-footer">
            <FooterPlatform/>
            </footer>
        </div>
    );
};
export default NotFoundPage;